
// Service options and plan options for the booking form
export const serviceOptions = [
  'Managed IT Services',
  'Cybersecurity',
  'Network & Infrastructure',
  'Cloud Solutions',
  'Project Consulting',
  'Specialty Services'
];

export const residentialServiceOptions = [
  'Managed IT Services',
  'Cybersecurity',
  'Network & Infrastructure',
  'Cloud Solutions',
  'Project Consulting',
  'Specialty Services',
  'Residential IT Support'
];

export const planOptions = [
  'Basic Support ($40/user/mo)',
  'Full Help Desk ($100/user/mo)',
  'Custom Solutions'
];

export const allPlanOptions = [
  'Basic Support ($40/user/mo)',
  'Full Help Desk ($100/user/mo)',
  'Custom Solutions',
  'Residential Hourly ($2.08/min)',
  'Residential Subscription ($29-99/mo)'
];

// Available time slots
export const timeSlots = [
  '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', 
  '11:00 AM', '11:30 AM', '1:00 PM', '1:30 PM', 
  '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', 
  '4:00 PM', '4:30 PM'
];

// Maps URL parameters to actual service names
export const mapServiceParam = (serviceParam: string | null): string => {
  if (!serviceParam) return '';
  
  const serviceMap: Record<string, string> = {
    'managed-it': 'Managed IT Services',
    'cybersecurity': 'Cybersecurity',
    'network': 'Network & Infrastructure',
    'cloud': 'Cloud Solutions',
    'consulting': 'Project Consulting',
    'specialty': 'Specialty Services',
    'residential': 'Residential IT Support'
  };
  
  return serviceMap[serviceParam] || '';
};

// Maps URL parameters to actual plan names
export const mapPlanParam = (planParam: string | null): string => {
  if (!planParam) return '';
  
  const planMap: Record<string, string> = {
    'basic': 'Basic Support ($40/user/mo)',
    'full': 'Full Help Desk ($100/user/mo)',
    'custom': 'Custom Solutions',
    'hourly': 'Residential Hourly ($2.08/min)',
    'subscription': 'Residential Subscription ($29-99/mo)'
  };
  
  return planMap[planParam] || '';
};
